import React, { Fragment, useEffect, useState }from 'react'
import { Icon, Row, Button } from 'antd';
import ApplicationForm from './ApplicationForm';
import { prop } from 'ramda';
import { withAsyncActions } from 'react-async-client';
import { getProjects } from 'actions/asyncActions';;

const Addapplication = ({ user, project_id, history, projectsData, getProjectId }) => {


    const [region, setRegion] = useState('')
    const [isOpen, setIsOpen] = useState(false)

    useEffect(()=> {
        projectsData.dispatch()
    }, [project_id])

    const onOpen  = () => {
        setIsOpen(state => !state)
        const { projects } = projectsData.data
        setRegion(projects && projects.find(item=> item.id === project_id).region.name.toLowerCase())
    }

    const clearProjectId = () => getProjectId('')

    const initialValues = {
        project_id,
        status: 'В работе',
        contact_email: prop('email', user),
        contact_phone: prop('phone_number', user),
        contact_name: prop('name', user),
        contact_surname: prop('surname', user),
        contact_patronymic: prop('patronymic', user),
    };

    return (
        <Fragment>
            <Row className="controls m-t-20 m-b-20">
                <Button type="primary" onClick={onOpen} disabled={project_id ? false : true} 
                    style={{ opacity: project_id ? 1 : 0.5 }}
                    title={project_id ? '' : "Необходимо заполнить поля формы проекта и сохранить её."}>
                    { !isOpen ? "Добавить заявку"  : "Отмена" }
                    { !isOpen ? <Icon type="plus" /> : null }
                </Button>
            </Row>
            { isOpen ? <ApplicationForm 
                inProjectAdd={true}
                project_id={project_id}
                initialValues={initialValues} 
                changelocation={{ location: region || "москва" }}
                history={history}
                clearProjectId={clearProjectId}
                {...this.props}
            /> : null }
        </Fragment>
    )   
}
const propsToAction = () => ({ projectsData: getProjects.withPayload(props=> props)})
export const AddapplicationWithCreateProject = withAsyncActions(propsToAction)(Addapplication)



// WEBPACK FOOTER //
// ./src/components/pages/projects/application/AddapplicationWithCreateProject.js